import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	designSectionLabel: {
		id: 'version-issue-associated-designs.design-section-label',
		defaultMessage: 'Designs',
		description:
			'The design section label in Version details page where we show all the associated designs for the version.',
	},
});
